import { useState } from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Modal } from '@mui/material';
import { useTranslation } from 'react-i18next';
import IsracardPopup from '../isracard-popup/IsracardPopup';

function AlternativeDealComponent({ price, nightCount, stars, hotelName, reviewCount, hotelCity, hotelCountry }) {
    const { t } = useTranslation();
    const [isOpenPopUp, setIsOpenPopUp] = useState(false);

    const handleArrowClick = (e) => {
        e.stopPropagation();
        setIsOpenPopUp(true);
    };

    return (
        <div className="alternative-deal">
            <div className="alternative-deal-content">
                <p className="alternative-deal-label">{t('AlternativeDeal.Label')}</p>
                <div className="alternative-deal-divider" />
                <div className="alternative-deal-price">
                    <p className="alternative-deal-price-text">
                        {t('AlternativeDeal.StartingFrom') + ' '}
                        <strong>{price}</strong>
                        {' ' + t('AlternativeDeal.For') + ' '}
                        <strong>{nightCount === 1 ? t('AlternativeDeal.OneNight') : t('AlternativeDeal.Nights', { count: nightCount })}</strong>
                    </p>
                    <div className="alternative-deal-tax">
                        <span>{t('AlternativeDeal.TaxIncluded')}</span>
                        <InfoOutlinedIcon className="alternative-deal-info-icon" />
                    </div>
                </div>
            </div>
            <button className="alternative-deal-arrow" data-testid="alternative-deal-book-btn" onClick={handleArrowClick}>
                <ArrowForwardIcon />
            </button>
            <Modal open={isOpenPopUp} onClose={() => setIsOpenPopUp(false)}>
                <div className="isracard-popup-modal-wrapper">
                    <IsracardPopup
                        isView={isOpenPopUp}
                        onClose={() => setIsOpenPopUp(false)}
                        price={price}
                        nights={nightCount}
                        stars={stars}
                        hotelName={hotelName}
                        reviewCount={reviewCount}
                        city={hotelCity}
                        country={hotelCountry}
                    />
                </div>
            </Modal>
        </div>
    );
}

export default AlternativeDealComponent;
